import { Component, OnInit, TemplateRef, ViewChild, ElementRef, NgZone, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import Swal from 'sweetalert2';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr'
import * as moment from 'moment';
import { AccessControlService } from 'src/app/services/access-control.service';
import { AlertService } from 'src/app/services/alert.service';
import { environment } from '../../../../environments/environment';
import { NgForm } from '@angular/forms';
import { StatusChange } from 'src/app/model/status-change.modal';
import { ActionTypeEnum } from 'src/app/enum/action-type-enum.enum';
import { RoleModal } from 'src/app/model/role.modal';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { map } from 'rxjs/operators';


type RequestStatus = "Saving.." | "Done";
@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],
  host: { '(window:custom-event)': 'updateNodes($event,$event.detail)' }
})
export class UserDashboardComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  id: any;
  model: any = {};
  applicationModel: any = [];
  blockButtonTitle: String;
  dynamicString: String;
  dropdownButtonTitle: string = 'Save';
  message: string = ''
  response: any = {};
  signed_up: String = ''
  dropdownList = [];
  roleDropdownList = [];
  roledropdownSettings = {};
  SelectedItems: any = [];
  selectedRoles: any = [];
  application: any = []
  roleList: any = []
  firstchar: String = '';
  lastchar: String = '';
  label_css: any;
  status: string;
  is_data: boolean = false
  change_btn_css: any
  application_code: any;
  serverUrl: any;
  allAssignedRoles: [];
  userForm: StatusChange;
  roleModal = new RoleModal();
  roleSelectedToRemove: any;
  appIdOfSelectedApp: any;
  clientId = localStorage.getItem('org_id');
  resetModel: { newPassword: string, confirmPassword: string };
  requestStatus: RequestStatus = "Done";
  @ViewChild('dropdown') dropdown: ElementRef
  accountHistoryDisplayedColumns: string[] = ['log.actionType', 'userDetail.username', 'log.reason', 'log.date', 'log.supportingFilePath.path'];
  loginHistoryDisplayedColumns: string[] = ['_id.application', 'ip', '_id.day'];
  UserApplicationsDisplayedColumns: string[] = ['application_name', 'roles._id', 'Actions'];

  @ViewChild('sort3', { read: MatSort }) sortloginHistory: MatSort;
  @ViewChild('sort1', { read: MatSort }) sortUserApp: MatSort;
  @ViewChild('sort2', { read: MatSort }) sortAccountHistory: MatSort;
  @ViewChild('paginator3') paginatorloginHistory: MatPaginator;
  @ViewChild('paginator1') paginatorUserApp: MatPaginator;
  @ViewChild('paginator2') paginatorAccountHistory: MatPaginator;

  accountHistorydataSource: MatTableDataSource<any>;
  accountHistorydataSource_noData: any;
  loginHistorydataSource: MatTableDataSource<any>;
  loginHistorydataSource_noData: any;
  userAppsdataSource: MatTableDataSource<any>;
  userAppsdataSource_noData: any;
  isSavingData: boolean = false
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  constructor(
    private modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService,
    private accessControlService: AccessControlService,
    private alertService: AlertService,
    private _ngZone: NgZone
  ) {
    this.id = this.activatedRoute.snapshot.params['id'];
    window['angularComponentRef'] = { component: this, zone: _ngZone };
  }

  ngOnInit() {
    this.roledropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 5,
      imitSelection: 5,
      allowSearchFilter: true,
      searchPlaceholderText: 'Search by name',
      noDataAvailablePlaceholderText: 'No data available',
    };
    this.getuserbyId();
    this.allapplications();
    this.populateUserLoginHistoryGrid();
    this.populateUserAccountHistoryGrid();
  }



  populateUserLoginHistoryGrid() {
    var Url = environment.serverUrl + 'access-control/history/' + this.id;
    this.accessControlService.getUserLoginHistory(this.id).subscribe((res) => {
      this.loginHistorydataSource = new MatTableDataSource<any>(res['rows']);
      this.loginHistorydataSource_noData = this.loginHistorydataSource.connect().pipe(map(data => data.length === 0));
      this.loginHistorydataSource.sortingDataAccessor = (item, property) => {
        return property.split('.').reduce((o, i) => o[i], item);
      };
      this.loginHistorydataSource.filterPredicate = function (data, filter): boolean {
        return data._id.application.toLowerCase().includes(filter)
      };
      this.loginHistorydataSource.paginator = this.paginatorloginHistory;
      this.loginHistorydataSource.sort = this.sortloginHistory;


    })
  }
  //Account history
  populateUserAccountHistoryGrid() {
    this.authService.getUserAccountHistory(this.id).subscribe((res: any) => {
      this.accountHistorydataSource = new MatTableDataSource<any>(res['rows']);
      this.accountHistorydataSource_noData = this.accountHistorydataSource.connect().pipe(map(data => data.length === 0));
      this.accountHistorydataSource.sortingDataAccessor = (item, property) => {
        return property.split('.').reduce((o, i) => o[i], item);
      };
      this.accountHistorydataSource.filterPredicate = function (data, filter): boolean {
        return data.log.actionType.toLowerCase().includes(filter) || data.userDetail.username.includes(filter) ||
          data.log.reason.toLowerCase().includes(filter) || data.log.date.includes(filter);
      };
      this.accountHistorydataSource.paginator = this.paginatorAccountHistory;
      this.accountHistorydataSource.sort = this.sortAccountHistory;
    })
  }
  fetchFile(fileId: string) {
    debugger;
    this.authService.getSupportingdoc(fileId, this.id).subscribe((res) => {
      var downloadURL = URL.createObjectURL(res);
      window.open(downloadURL);
    }
    );
  }
  openModal(template: TemplateRef<any>) {
    this.userForm = new StatusChange();
    this.resetModel = { newPassword: "", confirmPassword: "" }
    this.userForm.fileType = "-1";
    this.userForm.status = this.model.status;
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.userForm.userId = this.id;
    this.roleModal.fileType = "-1";
    this.roleModal.file = undefined;
    this.roleModal.reason = "";
    this.modalRef = this.modalService.show(template, config);
  }
  getuserbyId() {
    this.authService.getuserbyId(this.id).subscribe((res) => {
      this.model = res;
      if (this.model.firstname && this.model.lastname) {
        this.firstchar = this.model.firstname.charAt(0).toUpperCase();
        this.lastchar = this.model.lastname.charAt(0).toUpperCase();
      }
      if (this.model.status) {
        if (this.model.status == "ACTIVATED") {
          this.label_css = "badge badge-primary"
          this.status = 'ACTIVE'
        }
        if (this.model.status == "LOCKED") {
          this.label_css = "badge badge-danger"
          this.status = 'LOCKED'
        }
        if (this.model.status == "DE-ACTIVATED") {
          this.status = 'INACTIVE'
          this.label_css = "badge badge-warning"
        }
        if (this.model.status == "SUSPENDED") {
          this.status = 'SUSPENDED'
          this.label_css = "label label-default"
        }

      }
      this.signed_up = moment(this.model.signed_up).format("ddd DD-MM-YYYY hh:mm A");
      if (this.model.status + "" == "LOCKED") {
        // this.blockButtonTitle = 'Unblock it!'
        this.dropdownButtonTitle = "block"
        // this.dynamicString = 'enable'
        this.change_btn_css = "btn btn-danger btn-lg "
      }
      if (this.model.status + "" == "ACTIVATED") {
        this.dropdownButtonTitle = "Activate"
        this.change_btn_css = "btn btn-primary btn-lg grButton"
      }
      if (this.model.status + "" == "DE-ACTIVATED") {
        this.dropdownButtonTitle = "Deactivate"
        this.change_btn_css = "btn btn-warning btn-lg"
      }
      if (this.model.status == "SUSPENDED") {
        this.dropdownButtonTitle = "Suspend"
        this.change_btn_css = "btn btn-lg"
      }
    }, error => {
      console.log(error)
    },
      () => {

      })
  }
  changeButtonTitle(status) {
    if (status == "ACTIVATED") {
      this.dropdownButtonTitle = "Activate"
      this.change_btn_css = "btn btn-primary btn-md"
    }
    if (status == "DE-ACTIVATED") {
      this.dropdownButtonTitle = "Deactivate"
      this.change_btn_css = "btn btn-warning btn-md"
    }
    if (status == "LOCKED") {
      this.dropdownButtonTitle = "Block";
      this.change_btn_css = "btn btn-danger btn-md"

    }
    if (status == "SUSPENDED") {
      this.dropdownButtonTitle = "Suspend"
      this.change_btn_css = "btn btn-md"
    }
  }
  userRolesForApplication(applicationId: any) {
    if (this.applicationModel.length) {
      let userApp = this.applicationModel.find(x => x._id == applicationId);
      let userRoles = userApp.userlist.find(x => x._id == this.id);

      return userRoles.rolelist;
    }
  }
  allapplications() {
    let clientId = localStorage.getItem('org_id');
    this.accessControlService.userApplications(this.id, clientId).subscribe((res: []) => {
      this.applicationModel = res;
      this.userAppsdataSource = new MatTableDataSource<any>(res);
      this.userAppsdataSource_noData = this.userAppsdataSource.connect().pipe(map(data => data.length === 0));
      this.userAppsdataSource.filterPredicate = function (data, filter): boolean {
        return data.application_name.toLowerCase().includes(filter) || data.roles.some(x => x.name.toLowerCase().includes(filter))
      };
      this.userAppsdataSource.paginator = this.paginatorUserApp;
      this.userAppsdataSource.sort = this.sortUserApp;
      this.dropdownList = this.applicationModel
    }, error => {
      console.log(error)
    },
      () => {
      })
  }
  editRoute(value: any) {
    this.router.navigate(['edit-user/' + this.id], { queryParams: { option: value } });
  }
  verify() {
    let _this = this;
    Swal({
      title: 'Are you sure you want to delete this user?',
      text: "You won't be able to revert  this!",
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        // this should execute now
        _this.authService.deleteUser(_this.id, _this.clientId, { orginalClient: _this.model.org_id === _this.clientId }).subscribe((res) => {
          _this.toastrService.success("User deleted successfully.");
        }, error => { },
          () => {
            _this.router.navigate(["/user-listing"])
          })

      }

    })
  }
  verifyUnlinkApplication(application: any) {

    Swal({
      title: 'This operation will remove access of ' + this.model.email_id + ' from ' + application.application_name.toUpperCase() + '.Are you sure ? ',
      // type: 'warning',
      width: '44%',
      customClass: 'swal-height',
      showCancelButton: true,
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, Remove',
      position: 'center',
    }).then((result) => {
      if (result.value) {
        this.accessControlService.removeApplicationFromUser(application.application_id, this.id, this.clientId).subscribe((res) => {
        }, error => {
        }, () => {
          this.allapplications();
        })

      }
    })
  }

  getapplicationbyId(application) {
    this.accessControlService.getapplicationbyId(application._id).subscribe((res) => {
      this.application = res;
    }, error => {
      console.log(error)
    },
      () => {

      })
  }

  updateApplication() {
    this.application
    // var date = new Date();
    // this.model.updated_on = date
    this.accessControlService.updateApplication(this.application).subscribe((res) => {
      this.allapplications();
    }, error => {
      console.log(error)
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.alertService.errorAlert(errorMessage)
    }, () => {
    })
  }
  changeStatus(form: NgForm) {

    if (form.valid) {
      this.isSavingData = true
      this.userForm.actionType = ActionTypeEnum.STATUS_CHANGE;
      if (this.userForm.fileType == "application/rxd" || this.userForm.fileType == "-1") {
        delete this.roleModal.file;
      }
      this.authService.updateuserStatus(this.userForm).subscribe((res) => {
        this.response = res['actualStatus']
        if (this.response + "" == "LOCKED") {
          this.toastrService.error(this.model.email_id + ' has been LOCKED');
        }
        if (this.response + "" == "ACTIVATED") {
          this.toastrService.success(this.model.email_id + ' has been ACTIVATED');
        }
        if (this.response + "" == "DE-ACTIVATED") {
          this.toastrService.warning(this.model.email_id + ' has been DE-ACTIVATED');
        }
        if (this.response + "" == "SUSPENDED") {
          this.toastrService.info(this.model.email_id + ' has been SUSPENDED');
        }
        // else {
        //   this.toastrService.success(this.model.email_id + ' has been UnLOCKED');
        // }
        this.getuserbyId();
        this.populateUserAccountHistoryGrid();
        this.isSavingData = false
      }, error => { this.isSavingData = false },
        () => {
          this.isSavingData = false
          this.modalRef.hide();
        })
    } else {
      console.log('This form', form)
    }
  }
  getSelectedApplication(selected_application) {
    this.application_code = selected_application.application_id;
    this.authService.listRolesOfClientForApplication(selected_application.application_id, this.clientId).subscribe((res) => {
      this.roleList = res;
      this.roleDropdownList = this.roleList
      let app = this.userAppsdataSource.data.find(x => x._id == selected_application._id);
      if (app)
        this.roleDropdownList = this.roleDropdownList.filter(role => {
          return !app.roles.some(x => x._id == role._id);
        })
    }, error => {

    }, () => {
    })
  }
  assignRole(roleUpdateForm: NgForm) {
    this.roleModal.userId = this.id;
    this.roleModal.appId = this.application_code;
    this.roleModal.selectedRoles = this.selectedRoles;
    this.roleModal.actionType = ActionTypeEnum.ROLE_UPDATE;
    this.roleModal.clientId = this.clientId;
    this.selectedRoles.forEach((element) => {
      let user = this.roleDropdownList.find(x => x._id == element._id);
      if (user)
        element["isAdmin"] = user["isAdmin"] ? user["isAdmin"] : false;
    })
    debugger;
    if (this.roleModal.fileType == "application/rxd" || this.roleModal.fileType == "-1") {
      delete this.roleModal.file;
    }
    this.accessControlService.assignRole(this.roleModal).subscribe((res) => {
    }, error => {
      console.log(error)
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.alertService.errorAlert(errorMessage)
    }, () => {
      this.toastrService.success("Role assigned successfully.");
      this.allapplications();
      this.selectedRoles = [];
      this.modalRef.hide();
      this.populateUserAccountHistoryGrid();

    })
    // }
  }
  toggleClass() {
    if (this.dropdown.nativeElement.className.includes('open'))
      this.dropdown.nativeElement.className = 'dropdown';
    else
      this.dropdown.nativeElement.className = 'dropdown open';

  }
  onRoleSelect(event: Event) {

  }
  //removeRoleFromUser(applicationId:any,currentRoles:any){
  removeRoleFromUser() {
    if (this.roleSelectedToRemove) {
      this.roleModal.userId = this.id;
      this.roleModal.appId = this.appIdOfSelectedApp;
      this.roleModal.actionType = ActionTypeEnum.ROLE_DELETE;
      this.roleModal.clientId = this.clientId;
      if (this.roleModal.fileType == "application/rxd" || this.roleModal.fileType == "-1") {
        delete this.roleModal.file;
      }
      this.roleModal["roleid"] = this.roleSelectedToRemove._id;
      this.accessControlService.removeRole(this.roleModal).subscribe((res) => {
      }, error => {
        console.log(error)
        var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
        this.alertService.errorAlert(errorMessage)
      }, () => {
        this.toastrService.success("Role deleted successfully.");
        this.allapplications();
        this.selectedRoles = [];
        this.modalRef.hide();


      })
    }
  }
  openRoleDeletePrompt(deleteTemplate: TemplateRef<any>, appId: string, role: any) {
    let config = { backdrop: true, ignoreBackdropClick: true };
    this.roleModal = new RoleModal();
    this.roleModal.fileType = "-1";
    this.roleModal.reason = "";
    this.modalRef = this.modalService.show(deleteTemplate, config);
    this.roleSelectedToRemove = role;
    this.appIdOfSelectedApp = appId
  }
  getFiles(event: any, type: any) {
    debugger;
    if (event.target.files.length > 0) {
      if (ActionTypeEnum[type] == ActionTypeEnum.STATUS_CHANGE.toString()) {
        {
          this.userForm.file = event.target.files[0];
          this.userForm.fileName = event.target.files[0].name;
        }
      }
      else if (ActionTypeEnum[type] == ActionTypeEnum.ROLE_UPDATE || ActionTypeEnum[type] == ActionTypeEnum.ROLE_DELETE) {
        this.roleModal.file = event.target.files[0];
        this.roleModal.fileName = event.target.files[0].name;
      }
    }

  }

  ngOnDestroy() {
    window['angularComponent'] = null;
  }
  updateNodes(id: any) {
    this.fetchFile(id);
    //alert(JSON.stringify(detail));
  }
  applyFilter(event: Event, type: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    switch (type) {
      case 1:
        this.userAppsdataSource_noData = this.userAppsdataSource.connect().pipe(map(data => data.length === 0));
        this.userAppsdataSource.filter = filterValue.trim().toLowerCase();
        break;
      case 2:
        this.accountHistorydataSource_noData = this.accountHistorydataSource.connect().pipe(map(data => data.length === 0));
        this.accountHistorydataSource.filter = filterValue.trim().toLowerCase();
        break;
      case 3:
        this.loginHistorydataSource_noData = this.loginHistorydataSource.connect().pipe(map(data => data.length === 0));
        this.loginHistorydataSource.filter = filterValue.trim().toLowerCase();
        break;
    }
  }
  getDate(dayOfYear: number, year: number): Date {
    return new Date(year, 0, dayOfYear);
  }

  resetPassword() {
    this.requestStatus = "Saving..";
    this.authService.ResetPassword(this.id, this.clientId, this.resetModel).subscribe((res: any) => {
      if (!res.error) {
        this.toastrService.success("Password resetted successfully.");
        this.modalRef.hide();
        this.requestStatus = "Done";
      }

    }, error => {
      this.toastrService.error(error.message);
      this.modalRef.hide();
      this.requestStatus = "Done";

    })
  }
}
